import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getScheduleTypeValues, PopUpTypes } from '../../../utils/events';
import { updateEventSchedule } from '../../../actions/draw-edit-actions';
import EventDeskTabLayout from '../EventDeskTabLayout';
import ScheduleTypeOption, { scheduleTypeDescriptions } from './ScheduleTypeOption';
import { useStatsig } from '../../../components/hooks/useStatsig';

import styles from './scheduleTab.scss';
import PopupV3, { PopupTypes } from '../../../components/Popup/PopupV3';

const ScheduleTabV2 = () => {
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { event } = useSelector(({ drawEdit }) => {
        const { event } = drawEdit;
        return { event };
    });
    const dispatch = useDispatch();
    const { checkGate: checkStatsigGate } = useStatsig();

    const { drawScheduleTypes } = coreUI.types.tms;
    const { scheduleTypeId } = event.data || {};
    const [showChangeScheduleTypePopup, setShowChangeScheduleTypePopup] = useState(false);
    const [newScheduleType, setNewScheduleType] = useState(null);

    const scheduleTypeValues = getScheduleTypeValues({
        sportTypeId: event?.data?.sportTypeId,
        drawScheduleTypes,
        scheduleTypeDescriptions,
        checkStatsigGate,
    });

    const handleScheduleTypeClick = (val) => {
        setNewScheduleType(val);
        setShowChangeScheduleTypePopup(true);
    };

    const handleChangeConfirm = () => {
        dispatch(updateEventSchedule(newScheduleType)); // TODO:
        setShowChangeScheduleTypePopup(false);
    };

    return (
        <EventDeskTabLayout className={styles.scheduleTab}>
            <div className={styles.content}>
                <h4 className={styles.title} data-testid="schedule-tab.title">
                    Manage Event Schedule
                </h4>
                <p className={`${styles.subTitle} mb24`} data-testid="schedule-tab.subtitle">
                    How would you like your match schedule to be viewed/managed?
                </p>
                {scheduleTypeValues.map(scheduleType => (
                    <ScheduleTypeOption
                        key={`schedule-type-${scheduleType.id}`}
                        selectedScheduleTypeId={scheduleTypeId}
                        scheduleType={scheduleType}
                        handleScheduleTypeClick={handleScheduleTypeClick}
                        data-testid={`schedule-tab.type-${scheduleType.id}`}
                    />
                ))}
                <PopupV3
                    title="Confirm schedule type change"
                    message={PopUpTypes.CHANGE_SCHEDULE_TYPE.message}
                    type={PopupTypes.INFO}
                    isOpen={!!showChangeScheduleTypePopup}
                    onConfirmClick={handleChangeConfirm}
                    onCancelClick={() => {
                        setShowChangeScheduleTypePopup(false);
                    }}
                    showCancelButton
                />
            </div>
        </EventDeskTabLayout>
    );
};

ScheduleTabV2.defaultProps = {};

export default ScheduleTabV2;
